export const EULAPage: React.FC = () => (
  <embed
    src={process.env.PUBLIC_URL + '/END-USER LICENCE AGREEMENT (V2) 11 March 2026.pdf'}
    type="application/pdf"
    width="100%"
    height="100%"
  />
);
